export default __webpack_public_path__ + "static/media/PU-Pre-Insulated-Pipe.dbbb706a.PNG";